import React, { useEffect } from 'react';
import { Button, Image, Layout } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import routes from '../../../controller/Routes';
import { getCandidateLogo } from '../../../controller/localStroageHandler';
const { Header, Content } = Layout;

const Welcome = () => {
  const navigate = useNavigate();
  const logo=getCandidateLogo()
   useEffect(() => {
      const handleKeyPress = (event) => {
        if (event.keyCode === 27) {
          // Esc key
          event.preventDefault();
        }
        if (
          (event.ctrlKey || event.metaKey) &&
          (event.key.toLowerCase() === 'r' ||
            event.key.toLowerCase() === 'c' ||
            event.key.toLowerCase() === 's' ||
            event.key.toLowerCase() === 'x' ||
            event.key.toLowerCase() === 'n' ||
            event.key.toLowerCase() === 'f' ||
            event.key.toLowerCase() === 'tab')
        ) {
          event.preventDefault();
          console.log('prevent the tab and copy shortcut');
        }
        if ( event?.altKey) {
          event.preventDefault();
          console.log('prevent shift and alt key');
        }
        if (
          event.key &&
          event.key.startsWith('F') &&
          !isNaN(event.key.slice(1))
        ) {
          event.preventDefault();
          console.log('Function key press prevented');
        }
      };
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible') {
          console.log('visible');
        } else {
          console.log('hidden');
        }
      });
      const handleContextMenu = (event) => {
        event.preventDefault();
        console.log('Right-click context menu prevented');
      };
      document.addEventListener('keydown', handleKeyPress);
      document.addEventListener('contextmenu', handleContextMenu);
  
      return () => {
        document.removeEventListener('keydown', handleKeyPress);
        document.removeEventListener('contextmenu', handleContextMenu);
      };
    }, []);
  return (
    <Layout className='w-100 h-100'>
      <Header className='bg-white border-2 border-bottom border-color h-auto pt-2 pb-2'>
        <Image src={logo} className='logo' width={120} alt='' preview={false} />
      </Header>
      <Content className='h-100 w-100 background-image d-flex justify-content-center align-items-center'>
        <div className='text-center'>
          <span className='text-muted fs-5'>Get Your First Job!</span>
          <h2 className='fw-bolder'>Take Skill Test</h2>
          <Button
            type='primary'
            className='w-100 h-auto button-color p-2 d-flex justify-content-center align-items-center'
            onClick={() => {
              navigate(routes.test.detail);
            }}
          >
            Get Started <RightOutlined />
          </Button>
        </div>
      </Content>
    </Layout>
  );
};

export default Welcome;
